// Transportstyrelsen's six headings for a vehicle (Falu kommun, answer 504548): the card lists what
// the register returned under them, with Swedish labels. A key not listed here lands under
// "Övriga uppgifter", so a new source never hides a field.
export const REGISTER_HEADINGS: Array<{ title: string; fields: Record<string, string> }> = [
  {
    title: 'Fordonsidentitet',
    fields: {
      registreringsnummer: 'Registreringsnummer',
      chassinummer: 'Chassinummer (VIN)',
      fabrikat: 'Fabrikat',
      handelsbeteckning: 'Handelsbeteckning',
      fordonsar: 'Fordonsår',
      farg: 'Färg',
      fordonsslag: 'Fordonsslag',
      fordonskategori_eu: 'Fordonskategori EU',
      typgodkannandenummer: 'Typgodkännandenummer',
      variant_version: 'Variant och version',
    },
  },
  {
    title: 'Status',
    fields: {
      status: 'Fordonsstatus',
      forsta_registrering: 'Första registrering',
      registreringsdatum: 'Registreringsdatum',
      i_trafik_forsta_gang: 'I trafik första gången',
      avstalld: 'Avställt',
      korforbud: 'Körförbud',
      anvandningsforbud: 'Användningsförbud',
      import_inforsel: 'Import eller införsel',
      leasing: 'Leasing',
      kreditkop: 'Kreditköp',
      agare_typ: 'Ägare',
      antal_agare: 'Antal ägare',
      antal_brukare: 'Antal brukare',
      agarbyte_senast: 'Senaste ägarbyte',
    },
  },
  {
    title: 'Besiktning',
    fields: {
      senaste_besiktning: 'Senaste besiktning',
      besiktningsresultat: 'Besiktningsresultat',
      besiktning_senast: 'Besiktigas senast',
      besiktningsperiod_manader: 'Besiktningsperiod, månader',
      matarstallning_vid_besiktning: 'Mätarställning vid besiktning, km',
    },
  },
  {
    title: 'Skatt och avgifter',
    fields: {
      fordonsskatt_kr: 'Fordonsskatt, kr per år',
      skattemanad: 'Skattemånad',
      skatt_betald_till: 'Skatt betald till',
      fordonsskatt_betald: 'Fordonsskatt betald',
      skattepliktig: 'Skattepliktigt',
      malus_kr: 'Malus, kr',
      trangselskatt_skyldig: 'Trängselskattepliktigt',
      trangselskatt_obetald_kr: 'Obetald trängselskatt, kr',
      infrastrukturavgift_obetald_kr: 'Obetald infrastrukturavgift, kr',
      felparkeringsavgift_obetald_kr: 'Obetald felparkeringsavgift, kr',
      vagavgift_kravs: 'Vägavgift krävs',
    },
  },
  {
    title: 'Tekniska data',
    fields: {
      drivmedel: 'Drivmedel',
      motoreffekt_kw: 'Motoreffekt, kW',
      slagvolym_cm3: 'Slagvolym, cm³',
      vaxellada: 'Växellåda',
      drivhjul: 'Drivhjul',
      max_hastighet_km_h: 'Högsta hastighet, km/h',
      co2_blandad_g_km: 'Koldioxid blandad körning, g/km',
      utslappsklass: 'Utsläppsklass',
      miljoklass: 'Miljöklass',
      euro_nox_mg_km: 'Kväveoxider, mg/km',
      bullerniva_db: 'Bullernivå, dB',
      antal_sittplatser: 'Antal sittplatser',
      antal_passagerare: 'Antal passagerare',
      korkortsklass: 'Körkortsklass',
      tjanstevikt_kg: 'Tjänstevikt, kg',
      totalvikt_kg: 'Totalvikt, kg',
      maxlast_kg: 'Maxlast, kg',
      max_slapvikt_kg: 'Högsta släpvikt, kg',
      max_taklast_kg: 'Högsta taklast, kg',
      langd_mm: 'Längd, mm',
      bredd_mm: 'Bredd, mm',
      hojd_mm: 'Höjd, mm',
      axelavstand_mm: 'Axelavstånd, mm',
      antal_axlar: 'Antal axlar',
      kopplingsanordning: 'Kopplingsanordning',
      hjul_dack: 'Hjul och däck',
    },
  },
];

/** The first heading: the facts a person looks for first, drawn from the headings below. */
export const REGISTER_SUMMARY: Record<string, string> = {
  registreringsnummer: 'Registreringsnummer',
  fabrikat: 'Fabrikat',
  handelsbeteckning: 'Handelsbeteckning',
  fordonsar: 'Fordonsår',
  status: 'Fordonsstatus',
  besiktning_senast: 'Besiktigas senast',
  fordonsskatt_kr: 'Fordonsskatt, kr per år',
  drivmedel: 'Drivmedel',
};
